<template>
  <div :class="'sby-profile-card sby-profile-card--' + type">
    <div class="sby-profile-card__content van-hairline--bottom" @click="onClick">
      <template v-if="type === 'add'">
        <van-icon class="sby-profile-card__icon" name="add2"/>
        <div class="sby-profile-card__text">{{ viewText || addText }}</div>
      </template>
      <template v-else-if="type === 'edit'">
        <div class="sby-profile-card__text">
          <div style="font-weight:500;">
            <span style="display: inline-block; width: 55px;">{{ profile.name }}</span>
            <span>{{ hidePhoneNumber(profile.phone) }} <sby-member-icon v-if="profile.vip === 1"/></span>
          </div>
          <div>
            <van-tag
              type="primary"
              plain
              class="small-tag"
            >{{profile.relation ? profile.relation : '本人' }}</van-tag>
            <span style="color: #b1b1b1; font-size: 14px;margin-left: 25px;">
              {{ profile.id_number }} 
            </span>
          </div>
        </div>
      </template>

      <van-icon class="sby-profile-card__arrow" name="arrow" v-if="editable">
        <span class="arrow-text">选择</span>
      </van-icon>
    </div>
    <div class="add-profile-btn" v-if="editable" @click="addProfile()">
      <van-icon name="add-o"/>
      <span>添加参保人</span>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import { Icon, Cell, Tag } from "vant";
import Vue from "vue";
Vue.use(Icon);
Vue.use(Tag).use(Cell);

export default {
  name: "profile-card",
  props: {
    profile: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // 展示功能信息
    viewText: String,
    addText: String,
    editable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "add"
    }
  },
  methods: {
    onClick(event) {
      if (this.editable) {
        this.$emit("click", event);
      }
    },
    addProfile(event) {
      this.$emit("add", event);
    },
    hidePhoneNumber(phone) {
      if (phone) {
        return phone.substring(0, 3) + "****" + phone.substring(7, 11);
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/less/var.less";

.add-profile-btn {
  text-align: center;
  font-weight: 500;
  color: #0ba3d2;
  height: 30px;
  font-size: 14px;
  margin-top: 10px;
  padding-bottom: 2px;
  i {
    font-size: 16px;
    height: 20px;
    vertical-align: middle;
  }
}

.sby-profile-card {
  position: relative;
  background-color: white;
  .small-tag {
    padding: 0px 5px;
  }

  &:active {
    background-color: #e8e8e8;
  }

  &--uneditable {
    &:active {
      background-color: #fff;
    }
  }

  &--add {
    line-height: 40px;

    .sby-profile-card__icon {
      width: 40px;
      color: #38f;
      font-size: 40px;
    }
  }

  &--edit {
    .sby-profile-card__icon {
      font-size: 18px;
      vertical-align: top;
    }
  }

  &__content {
    padding: 10px 15px;
  }

  &__icon,
  &__text {
    display: inline-block;
    vertical-align: middle;
  }

  &__icon {
    margin-right: 5px;
  }

  &__text {
    line-height: 24px;
    font-size: 16px;
  }

  &__arrow {
    top: 50%;
    right: 15px;
    font-size: 14px;
    position: absolute;
    color: #999;
    transform: translate3d(0, -50%, 0);
    .arrow-text {
      position: absolute;
    left: -27px;
    top: -2px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sby-profile-card.vue